// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal__Modal__cd320","Open":"Modal__Open__3Wyjm","CloseButton":"Modal__CloseButton__12xLZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/Modal.css
// module id = 50
// module chunks = 0